import Http from 'components/http/Http';
import JSON5 from 'json5';


const SERVER_DATA_GLOBAL = 'server_data';
const DEFAULT_CLIENT_CONFIG = {
  learn: false,
};


/*
 * Mapping to be kept in sync with server.
 *
 * {
 *   user: {
 *     email: "foo@bar.com",
 *   }
 *   csrf: "token value",
 * }
 *
 */


class Server {
  constructor() {
    this.http = new Http.Factory().create();
    this.http.responseInterceptor(this._onHttpResponse.bind(this));
    this.http.setCsrfFn(this.csrf.bind(this));
    this._data = null;
    this._loaded = false;
    this._callbacks = [];
    this._initialDataCallbacks = [];
    this._clientConfig = DEFAULT_CLIENT_CONFIG;
    this.doUpdate(window[SERVER_DATA_GLOBAL]);
    this.getInitialData();
    this.setClientConfig();
  }

  setClientConfig() {
    const _cfg = JSON5.parse(
        new URLSearchParams(document.location.search).get('_cfg'));
    this._clientConfig = Object.assign(this._clientConfig, _cfg);
  }

  update(newData) {
    this.doUpdate(newData);
  }

  get(field) {
    return field.split('.')
        .reduce(
            (data, key) => data === undefined ? data : data[key],
            this._data || {});
  }

  _onHttpResponse(rsp) {
    const serverData = rsp.body && rsp.body[SERVER_DATA_GLOBAL];
    if (serverData) {
      this.doUpdate(serverData);
    }
  }

  async getInitialData() {
    try {
      await this.http.get('/state');
      this._loaded = true;
      this._initialDataCallbacks.forEach(callback => callback());
    } catch(error) {
      console.log('Server - error!');
      console.log(error);
      return;
    }
  }

  doUpdate(newData) {
    this._data = Object.assign({}, this._data, newData);
    this._callbacks.forEach(callback => callback(this._data));
  }

  isInitialDataLoaded() {
    return this._loaded;
  }

  listen(callback) {
    this._callbacks.push(callback);
  }

  listenForInitialData(callback) {
    if (this.isInitialDataLoaded()) {
      callback();
      return;
    }
    this._initialDataCallbacks.push(callback);
  }

  // Accessor methods.

  cfg(val) {
    return this._clientConfig[val];
  }

  user_email() {
    return this.get('user.email');
  }

  csrf() {
    return this.get('csrf');
  }

  a() {
    return this.get('a');
  }
}

Server.SERVER_DATA_GLOBAL = SERVER_DATA_GLOBAL;

Server.Factory = class {
  create() {
    return _instance;
  }
}


const _instance = new Server();


export default Server;
